// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__Xrq4v","btnText":"button_btnText__cd7OD","slideTransition":"button_slideTransition__AgzgX"};